import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import ThemedHomecardWrapper from '../../common/ThemedHomecardWrapper';

import styles from './HomecardWrapper.module.scss';

const cx = classNames.bind(styles);

class HomecardWrapper extends PureComponent {
  state = {
    hovered: false
  };

  handleMouseEnter = () => {
    this.setHover();
    this.props.onMouseEnter();
  };

  handleMouseLeave = () => {
    this.unsetHover();
    this.props.onMouseLeave();
  };

  handleTouchStart = () => {
    this.setHover();
  };

  handleTouchEnd = () => {
    this.unsetHover();
  };

  getLinkClassName = () => {
    const { selected, horizontal, zoomOnHover } = this.props;
    const { hovered } = this.state;

    return cx(styles['home-card'], {
      [styles['home-card--horizontal']]: horizontal,
      [styles['home-card--selected']]: selected,
      [styles['home-card--image-zoom']]: hovered && zoomOnHover
    });
  };

  getDivClassName = () => cx(styles['home-card']);

  setHover = () => {
    if (!this.props.selected) {
      this.setState({ hovered: true });
    }
  };

  unsetHover = () => {
    if (!this.props.selected) {
      this.setState({ hovered: false });
    }
  };

  render() {
    const { link, ...restProps } = this.props;

    const theme = {
      wrapper: link ? this.getLinkClassName() : this.getDivClassName()
    };

    return (
      <ThemedHomecardWrapper
        {...restProps}
        link={link}
        theme={theme}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onTouchStart={this.handleTouchStart}
        onTouchEnd={this.handleTouchEnd}
      />
    );
  }
}

HomecardWrapper.propTypes = {
  className: PropTypes.string,
  link: PropTypes.string,
  newTab: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  renderContent: PropTypes.func,
  renderImage: PropTypes.func,
  selected: PropTypes.bool,
  horizontal: PropTypes.bool,
  hasLazyLoad: PropTypes.bool,
  isMinimalRoundedCard: PropTypes.bool,
  zoomOnHover: PropTypes.bool
};

HomecardWrapper.defaultProps = {
  className: '',
  link: '',
  newTab: true,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  renderContent: () => {},
  renderImage: () => {},
  selected: false,
  horizontal: false,
  isMinimalRoundedCard: false,
  hasLazyLoad: true,
  zoomOnHover: false
};

export default HomecardWrapper;
